import { Injectable } from '@angular/core';
import { ApiClientService } from '../../core/services/api-client.service';
import { GlobalConfig } from './global-config.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalService extends ApiClientService {
  /**
   * Retrieves the global application configuration
   * GET /config/global
   */
  getGlobalConfig() {
    return this.get<GlobalConfig>('/config/global');
  }

  /**
   * Updates the global configuration
   * PUT /config/global
   */
  updateGlobalConfig(config: GlobalConfig) {
    return this.put<GlobalConfig>('/config/global', config);
  }
}
